import React, { useEffect, useState } from 'react';
import { useAuth } from "../../utils/AuthContext/authcontext";
import { useTranslation } from 'react-i18next';
import { useNotifications } from "../../utils/NotificationContext/NotificationContext";
import { HiBellAlert, HiBell } from 'react-icons/hi2';
import styles from './NotificationBadge.module.css';

export default function NotificationBadge() {
  const { user } = useAuth();
  const [unreadCount, setUnreadCount] = useState(0);
  const { notifications } = useNotifications();

  useEffect(() => {
    if (!user) return;
      const unread = notifications.filter(n => !n.read).length;
      setUnreadCount(unread);
	  
  }, [notifications]);

  return (
    <div className={styles.badgeContainer}>
      {unreadCount <= 0 ? <HiBell className={styles.icon} /> : <HiBellAlert className={styles.icon} />}
      {unreadCount > 0 && <div className={styles.badge}>{unreadCount}</div>}
    </div>
  );
}
